export default { sha: 'c668f91a0199527655b70123142dc8ee9dd8e2e3', buildNumber: 'undefined' }
